export const apiNameify = (s: string) => {
  return s
    .trim()
    .replace(/[^a-zA-Z0-9]+/gi, '_')
    .toLowerCase();
};
